module.exports = __webpack_public_path__ + "img/其他设备.802391c0.png";